import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const NAV_GROUPS = [
  {
    label: 'Overview',
    items: [{ id: 'dashboard', label: 'Dashboard' }],
  },
  {
    label: 'Trade',
    items: [
      { id: 'trade', label: 'Trade' },
      { id: 'orders', label: 'Orders' },
    ],
  },
  {
    label: 'Research',
    items: [
      { id: 'signals', label: 'Signals' },
      { id: 'research', label: 'Research' },
      { id: 'manager', label: 'AI Manager' },
    ],
  },
  {
    label: 'Portfolio',
    items: [
      { id: 'analysis', label: 'Analysis' },
      { id: 'risk', label: 'Risk' },
    ],
  },
];

const ROUTE_LINKS = [
  { label: 'Watchlists', to: '/watchlists' },
  { label: 'Markets', to: '/markets' },
];

export default function Sidebar({ activeTab, onTabChange, brokerStatus }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <aside className="app-sidebar">
      <div className="sidebar-brand">
        <span className="brand-mark">Q</span>
        <span className="brand-title">QuantumTrade</span>
      </div>

      <nav className="sidebar-nav">
        {NAV_GROUPS.map((group) => (
          <div key={group.label}>
            <p className="sidebar-group-label">{group.label}</p>
            <div className="sidebar-group-items">
              {group.items.map((item) => (
                <button
                  key={item.id}
                  onClick={() => onTabChange(item.id)}
                  className={`nav-button ${activeTab === item.id ? 'active' : ''}`}
                  aria-current={activeTab === item.id ? 'page' : undefined}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        ))}

        <div>
          <p className="sidebar-group-label">Markets</p>
          <div className="sidebar-group-items">
            {ROUTE_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className={`nav-button ${location.pathname === link.to ? 'active' : ''}`}>
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="sidebar-group-label">Account</p>
          <div className="sidebar-group-items">
            <Link
              to="/connect-broker"
              className={`nav-button ${location.pathname === '/connect-broker' ? 'active' : ''}`}
            >
              Connect Broker
            </Link>
            <Link to="/security" className={`nav-button ${location.pathname === '/security' ? 'active' : ''}`}>
              Security
            </Link>
            <Link to="/billing" className={`nav-button ${location.pathname === '/billing' ? 'active' : ''}`}>
              Billing
            </Link>
            <Link to="/settings" className={`nav-button ${location.pathname === '/settings' ? 'active' : ''}`}>
              Settings
            </Link>
            <Link to="/legal" className={`nav-button ${location.pathname === '/legal' ? 'active' : ''}`}>
              Legal
            </Link>
          </div>
        </div>
      </nav>

      <div className="sidebar-footer">
        <Link
          to="/connect-broker"
          className={`status-pill-link ${brokerStatus?.connected ? brokerStatus.environment : 'off'}`}
        >
          <span className="status-dot" />
          {brokerStatus?.connected ? `${brokerStatus.environment.toUpperCase()} CONNECTED` : 'CONNECT BROKER'}
        </Link>
        <div className="user-menu">
          <span className="user-name">{user?.displayName}</span>
          <button className="text-button" onClick={handleLogout}>
            Sign out
          </button>
        </div>
      </div>
    </aside>
  );
}
